import { render, staticRenderFns } from "./baseMessage.vue?vue&type=template&id=ae099590&scoped=true"
import script from "./baseMessage.vue?vue&type=script&lang=js"
export * from "./baseMessage.vue?vue&type=script&lang=js"
import style0 from "./baseMessage.vue?vue&type=style&index=0&id=ae099590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae099590",
  null
  
)

export default component.exports